import { useContext, useEffect, useState } from "react";
import { useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useOurEvents = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr } = useService("Data", "event");
  const { setTitle, setDescription, setKeywords } = useService("Meta");
  const [eventList, seteventList] = useState([]);

  useEffect(() => {
    setTitle("Carmitra Events | Explore Workshops & Live Drives", "empty");
    setDescription(
      "Join Carmitra events, live drives, and car care workshops. Discover innovations, connect with experts, and experience auto service like never before!"
    );
    setKeywords(
      "Carmitra events, auto workshops, car service events, live car drives, auto shows India, vehicle care seminars, car maintenance event, car care live demo, Carmitra roadshows, auto innovation events"
    );
    getEventData();
  }, []);

  const viewEvent = (slug) => {
    navigateTo({ route: `/event/${slug}` });
  };

  const getEventData = async () => {
    const result = await fetchByAttr({ status: "publish" });
    if (result.status) seteventList(result.data);
  };
  return {
    eventList,
    viewEvent,
  };
};
